import lib from '@/library'

const state = {
  registrationStatus: { state: null, response: null },
  activationStatus: { state: null, response: null },
  limits4session: {
    singleSessionLimit: null,
    dailyLimit: null,
    weeklyLimit: null,
    monthlyLimit: null,
    maxSingleSessionLimit: null,
    maxDailyLimit: null,
    maxWeeklyLimit: null,
    maxMonthlyLimit: null
  },
  limits4sessionStatus: { state: null, response: null },
  limits4depositStatus: { state: null, response: null }
}

const getters = {
  getRegistrationStatus (state) {
    return state.registrationStatus
  },
  getActivationStatus (state) {
    return state.activationStatus
  },
  getLimits4Session (state) {
    return state.limits4session
  },
  getLimits4SessionStatus (state) {
    return state.limits4sessionStatus
  },
  getLimits4DepositStatus (state) {
    return state.limits4depositStatus
  },
  getIsOpenedFromWebView (state) {
    let check = ('webView' in localStorage) ? JSON.parse(localStorage.getItem('webView')) : false
    return JSON.parse(check)
  },
  getDevice (getters) {
    var device = ''

    if (/Android/i.test(navigator.userAgent)) {
      if (getters.isOpenedFromWebView) {
        device = 'ANDROID_PHONE'
      } else {
        device = 'ANDROID_PHONE_HTML5'
      }
    } else if (/iPhone/i.test(navigator.userAgent)) {
      if (getters.isOpenedFromWebView) {
        device = 'IOS_PHONE'
      } else {
        device = 'IOS_PHONE_HTML5'
      }
    } else if (/iPad|iPod/i.test(navigator.userAgent)) {
      if (getters.isOpenedFromWebView) {
        device = 'IOS_TABLET'
      } else {
        device = 'IOS_TABLET_HTML5'
      }
    } else {
      device = 'OTHERS'
    }

    return device
  }
}

const actions = {
  /**
   * Will reset account state to its initial values, suitable for logout/chage user scenarios
   * @param {any} context
   * @param {any} data
   */
  resetAccountStates (context, data) {
    let limits4s = {
      singleSessionLimit: null,
      dailyLimit: null,
      weeklyLimit: null,
      monthlyLimit: null,
      maxSingleSessionLimit: null,
      maxDailyLimit: null,
      maxWeeklyLimit: null,
      maxMonthlyLimit: null
    }
    context.commit('setLimits4Session', limits4s)
  },
  /**
   * Check if token is valid
   * @param {any} context
   * @param {any} data
   */
  validateToken (context, data) {
    let stamp = data.stamp ? data.stamp : new Date().getTime()
    let pDevice = context.getters['getDevice']
    let pToken = data.token

    return new Promise((resolve, reject) => {
      lib.rpcService.callBroker('IGTConnectService', 'ValidateToken', { IDMDRegion: 'ignore', IDMDLanguage: 'ignore', 'device': pDevice, 'token': pToken }
      ).then(response => {
        response = lib.rpcService.completeIgtcResponse(response)
        response.stamp = stamp
        resolve(response)
      }).catch((response) => {
        response = lib.rpcService.completeIgtcResponse(response)
        response.stamp = stamp
        reject(response)
      })
    })
  },
  register (context, data) {
    let pDevice = context.getters['getDevice']
    let pEmail = data.email
    let pPassword = data.password
    let pFirtsName = data.firtsname
    let pMiddleName = data.middlename
    let pLastName = data.lastname
    let pGender = data.gender
    let pDob = data.dob
    let pPhoneNumber = data.phonenumber
    let pMobileNumber = data.mobilenumber
    let pAddress = data.address
    let pAddressLine2 = data.addressline2
    let pZipCode = data.zipcode
    let pCity = data.city
    let pState = data.state
    let pSsn = data.ssn
    let pSecurityQuestionAndAnswer = data.securityquestionandanswers
    let pRreceiveEmailsAboutWinningBets = data.preceivesmsaboutwinningbets
    let pReceiveEmailsAboutPromotions = data.receiveemailsaboutpromotions
    let pReceiveSmsAboutWinningBets = data.receivesmsaboutwinningbets
    let pReceiveSmsAboutPromotions = data.receivesmsaboutpromotions
    let pIsResident = data.isresident

    let timestamp = new Date().getTime()
    state.tsRqH = timestamp

    context.commit('setRegistrationStatus', { state: 'registering', response: null })

    var userData = {
      'Email': pEmail,
      'Password': pPassword,
      'FirstName': pFirtsName,
      'MiddleName': pMiddleName,
      'LastName': pLastName,
      'Gender': pGender,
      'Dob': pDob,
      'PhoneNumber': pPhoneNumber,
      'MobileNumber': pMobileNumber,
      'AddressLine1': pAddress,
      'AddressLine2': pAddressLine2,
      'ZipCode': pZipCode,
      'City': pCity,
      'State': pState,
      'Ssn': pSsn,
      'SecurityQuestionAndAnswers': pSecurityQuestionAndAnswer,
      'ReceiveEmailsAboutWinningBets': pRreceiveEmailsAboutWinningBets,
      'ReceiveEmailsAboutPromotions': pReceiveEmailsAboutPromotions,
      'ReceiveSmsAboutWinningBets': pReceiveSmsAboutWinningBets,
      'ReceiveSmsAboutPromotions': pReceiveSmsAboutPromotions,
      'isResident': pIsResident
    }
    lib.rpcService.callBroker('IGTConnectService', 'Register', { IDMDRegion: 'ignore', IDMDLanguage: 'ignore', device: pDevice, data: userData }).then(response => {
      if (state.tsRqH === timestamp) {
        let response2 = lib.rpcService.completeIgtcResponse(response)
        state.tsRqH = 0
        let rstate = null
        if (response2 && response2.result && response2.result.error_code === '0' && response2.result.error_message === null) {
          rstate = 'reg-success'
        } else if (response2 && response2.result && response2.result.error_code !== '0') {
          rstate = 'reg-error'
        } else {
          rstate = 'reg-unkerror'
        }
        context.commit('setRegistrationStatus', { state: rstate, response: response2 })
      }
    }).catch((response) => {
      if (state.tsRqH === timestamp) {
        let response2 = lib.rpcService.completeIgtcResponse(response)
        state.tsRqH = 0
        context.commit('setRegistrationStatus', { state: 'reg-unkerror', response: response2 })
      }
    })
  },
  activateAccount (context, data) {
    let pDevice = context.getters['getDevice']
    let pActivationCode = data.activationCode

    let timestamp = new Date().getTime()
    state.tsRqH = timestamp

    context.commit('setActivationStatus', { state: 'activating', response: null })

    return new Promise((resolve, reject) => {
      lib.rpcService.callBroker('IGTConnectService', 'ActivateAccount', { IDMDRegion: 'ignore', IDMDLanguage: 'ignore', 'device': pDevice, 'activationCode': pActivationCode })
      .then(response => {
        if (state.tsRqH === timestamp) {
          response = lib.rpcService.completeIgtcResponse(response)

          state.tsRqH = 0
          let rstate = null
          if (response && response.result && response.result.error_code === '0' && response.result.error_message === null) {
            rstate = 'activation-success'
          } else if (response && response.result && response.result.error_code !== '0') {
            rstate = 'activation-error'
          }
          context.commit('setActivationStatus', { state: rstate, response: response })
        }
      }).catch((error) => {
        if (state.tsRqH === timestamp) {
          error = lib.rpcService.completeIgtcResponse(error)
          state.tsRqH = 0
          if (error.message === 'TOKEN_TIMED_OUT' || error.message === 'TOKEN_ALREADY_ACTIVATED' || error.message === 'TOKEN_INVALID') {
            context.commit('setActivationStatus', { state: 'activation-error', response: error })
          } else {
            context.commit('setActivationStatus', { state: 'activation-unkerror', response: error })
          }
        }
      })
    })
  },
  fetchSecurityQuestions (context, data) {
    let pDevice = context.getters['getDevice']
    let stamp = data.stamp ? data.stamp : new Date().getTime()
    let pEmail = data.email

    return new Promise((resolve, reject) => {
      lib.rpcService.callBroker(
        'IGTConnectService',
        'GetSecurityQuestions',
        { IDMDRegion: 'ignore', IDMDLanguage: 'ignore', 'device': pDevice, 'email': pEmail, 'type': 'email' }
      ).then(response => {
        response = lib.rpcService.completeIgtcResponse(response)
        response.stamp = stamp
        resolve(response)
      }).catch((response) => {
        response = lib.rpcService.completeIgtcResponse(response)
        response.stamp = stamp
        reject(response)
      })
    })
  },
  resetPassword (context, data) {
    let pDevice = context.getters['getDevice']
    let stamp = data.stamp ? data.stamp : new Date().getTime()
    let pEmail = data.email
    let pSecurityQ = data.securityquestion
    let pSecurityA = data.securityanswer

    let sqaData = { 'Answer': pSecurityA, 'Id': pSecurityQ }

    return new Promise((resolve, reject) => {
      lib.rpcService.callBroker(
        'IGTConnectService',
        'ResetPassword',
        { IDMDRegion: 'ignore', IDMDLanguage: 'ignore', 'device': pDevice, 'email': pEmail, 'securityAnswer': sqaData }
      ).then(response => {
        response = lib.rpcService.completeIgtcResponse(response)
        response.stamp = stamp
        resolve(response)
      }).catch((response) => {
        response = lib.rpcService.completeIgtcResponse(response)
        response.stamp = stamp
        reject(response)
      })
    })
  },
  changePassword (context, data) {
    let pDevice = context.getters['getDevice']
    let currentpassword = data.currentpassword
    let newpassword = data.newpassword
    return new Promise((resolve, reject) => {
      lib.rpcService.callBroker('IGTConnectService', 'PasswordChange', {
        'passwordChangeRequest': {
          'Device': pDevice,
          'OldPassword': currentpassword,
          'NewPassword': newpassword
        }
      }).then((response) => {
        response = lib.rpcService.completeIgtcResponse(response)
        resolve(response)
      }).catch((error) => {
        error = lib.rpcService.completeIgtcResponse(error)
        reject(error)
      })
    })
  },
  changePasswordWithToken (context, data) {
    let stamp = data.stamp ? data.stamp : new Date().getTime()
    let pDevice = context.getters['getDevice']
    let pToken = data.token
    let pNewPassword = data.newpassword
    return new Promise((resolve, reject) => {
      lib.rpcService.callBroker(
        'IGTConnectService',
        'ChangePasswordWithToken',
        { IDMDRegion: 'ignore', IDMDLanguage: 'ignore', 'device': pDevice, 'token': pToken, 'newPassword': pNewPassword }
      ).then((response) => {
        response = lib.rpcService.completeIgtcResponse(response)
        response.stamp = stamp
        resolve(response)
      }).catch((response) => {
        response = lib.rpcService.completeIgtcResponse(response)
        response.stamp = stamp
        reject(response)
      })
    })
  },
  fetchLimits4Session (context, data) {
    let pDevice = context.getters['getDevice']

    let timestamp = new Date().getTime()
    state.tsRqH = timestamp

    context.commit('setLimits4SessionStatus', { state: 'fetching', response: null })

    return new Promise((resolve, reject) => {
      lib.rpcService.callBroker(
        'IGTConnectService',
        'GetSessionLimits',
        { IDMDRegion: 'ignore', IDMDLanguage: 'ignore', 'device': pDevice }
      ).then(response => {
        if (state.tsRqH === timestamp) {
          response = lib.rpcService.completeIgtcResponse(response)
          let limits = null

          state.tsRqH = 0
          let rstate = null
          if (response && response.result && response.result.error_code === '0' && response.result.error_message === null) {
            rstate = 'fetch-success'
            limits = response.result.limits ? response.result.limits : null
            context.commit('setLimits4Session', limits)
          } else if (response && response.result && response.result.error_code !== '0') {
            rstate = 'fetch-error'
          }
          context.commit('setLimits4SessionStatus', { state: rstate, response: response })
          resolve(limits)
        }
      }).catch((error) => {
        if (state.tsRqH === timestamp) {
          error = lib.rpcService.completeIgtcResponse(error)
          state.tsRqH = 0
          context.commit('setLimits4SessionStatus', { state: 'fetch-unkerror', response: error })
          reject(error)
        }
      })
    })
  },
  updateLimits4Session (context, data) {
    let pDevice = context.getters['getDevice']
    let pSingleSessionLimit = data.singlesessionlimit
    let pDailyLimit = data.dailylimit
    let pWeeklyLimit = data.weeklylimit
    let pMonthlyLimit = data.monthlylimit
    let pMaxSingleSessionLimit = data.maxsinglesessionlimit
    let pMaxDailyLimit = data.maxdailylimit
    let pMaxWeeklyLimit = data.maxweeklylimit
    let pMaxMonthlyLimit = data.maxmonthlylimit
    let limits = {
      'SingleSessionLimit': pSingleSessionLimit,
      'DailyLimit': pDailyLimit,
      'WeeklyLimit': pWeeklyLimit,
      'MonthlyLimit': pMonthlyLimit,
      'MaxSingleSessionLimit': pMaxSingleSessionLimit,
      'MaxDailyLimit': pMaxDailyLimit,
      'MaxWeeklyLimit': pMaxWeeklyLimit,
      'MaxMonthlyLimit': pMaxMonthlyLimit
    }

    context.commit('setLimits4SessionStatus', { state: 'updating', response: null })

    return new Promise((resolve, reject) => {
      lib.rpcService.callBroker('IGTConnectService', 'UpdateSessionLimits', { IDMDRegion: 'ignore', IDMDLanguage: 'ignore', 'device': pDevice, 'sessionLimits': limits }).then(response => {
        response = lib.rpcService.completeIgtcResponse(response)
        state.tsRqH = 0
        let rstate = null
        if (response && response.result && response.result.error_code === '0' && response.result.error_message === null) {
          rstate = 'setlimit-success'
        } else if (response && response.result && response.result.error_code !== '0') {
          rstate = 'setlimit-error'
        }
        context.commit('setLimits4SessionStatus', { state: rstate, response: response })
        resolve(response)
      }).catch((error) => {
        error = lib.rpcService.completeIgtcResponse(error)
        context.commit('setLimits4SessionStatus', { state: 'setlimit-unkerror', response: error })
        reject(error)
      })
    })
  },
  fetchLimits4Deposit (context, data) {
    let pDevice = context.getters['getDevice']

    let timestamp = new Date().getTime()
    state.tsRqH = timestamp

    context.commit('setLimits4DepositStatus', { state: 'fetching', response: null })

    return new Promise((resolve, reject) => {
      lib.rpcService.callBroker(
        'IGTConnectService',
        'GetDepositLimit',
        { IDMDRegion: 'ignore', IDMDLanguage: 'ignore', 'device': pDevice, 'timeStamp': timestamp }
      ).then(response => {
        if (state.tsRqH === timestamp) {
          response = lib.rpcService.completeIgtcResponse(response)
          let limits = []

          state.tsRqH = 0
          let rstate = null
          if (response && response.result && response.result.error_code === '0' && response.result.error_message === null) {
            rstate = 'fetch-success'
            limits = response.result.limits ? response.result.limits : []
          } else if (response && response.result && response.result.error_code !== '0') {
            rstate = 'fetch-error'
          }
          context.commit('setLimits4DepositStatus', { state: rstate, response: response })
          resolve(limits)
        }
      }).catch((error) => {
        if (state.tsRqH === timestamp) {
          error = lib.rpcService.completeIgtcResponse(error)
          state.tsRqH = 0
          context.commit('setLimits4DepositStatus', { state: 'fetch-unkerror', response: null })
          reject(error)
        }
      })
    })
  },
  updateLimits4Deposit (context, data) {
    let pDevice = context.getters['getDevice']
    let pLimits = data.limits ? data.limits : []

    context.commit('setLimits4DepositStatus', { state: 'updating', response: null })

    return new Promise((resolve, reject) => {
      lib.rpcService.callBroker('IGTConnectService', 'UpdateDepositLimits', { IDMDRegion: 'ignore', IDMDLanguage: 'ignore', 'device': pDevice, 'depositLimits': pLimits }).then(response => {
        response = lib.rpcService.completeIgtcResponse(response)
        let limits = []
        let rstate = null

        if (response && response.result && response.result.error_code === '0' && response.result.error_message === null) {
          rstate = 'setlimit-success'
          limits = response.result.limits ? response.result.limits : []
        } else if (response && response.result && response.result.error_code !== '0') {
          rstate = 'setlimit-error'
        }
        context.commit('setLimits4DepositStatus', { state: rstate, response: response })
        resolve(limits)
      }).catch((error) => {
        error = lib.rpcService.completeIgtcResponse(error)
        state.tsRqH = 0
        context.commit('setLimits4DepositStatus', { state: 'setlimit-unkerror', response: error })
        reject(error)
      })
    })
  },
  fetchTransactions (context, data) {
    let pDevice = context.getters['getDevice']
    let stamp = data.stamp ? data.stamp : new Date().getTime()
    let pdatefrom = data.datefrom ? data.datefrom : (new Date().getTime() - (7 * 24 * 60 * 60 * 1000))
    let pdateto = data.dateto ? data.dateto : new Date().getTime()
    let ppagesize = data.pagesize ? data.pagesize : 10

    let hrparams = {
      'DateFrom': pdatefrom,
      'DateTo': pdateto,
      'Size': ppagesize,
      'Types': null,
      'Statistic': null,
      'Product': null
    }
    // p to today and 8191 for type, 29 for statistics, 60 for products

    return new Promise((resolve, reject) => {
      lib.rpcService.callBroker('IGTConnectService', 'GetTransactionHistory', { IDMDRegion: 'ignore', IDMDLanguage: 'ignore', 'device': pDevice, 'historyRequest': hrparams }).then(response => {
        response = lib.rpcService.completeIgtcResponse(response)
        let rstate = null

        if (response && response.result && response.result.error_code === '0' && response.result.error_message === null) {
          rstate = 'fetch-success'
        } else if (response && response.result && response.result.error_code !== '0') {
          rstate = 'fetch-error'
        }

        if (typeof response.result.transactions === 'undefined' || !Array.isArray(response.result.transactions)) { response.result.transactions = [] }

        response.stamp = stamp
        response.state = rstate
        resolve(response)
      }).catch((response) => {
        response = lib.rpcService.completeIgtcResponse(response)

        if (!Array.isArray(response.transactions)) { response.transactions = [] }

        response.stamp = stamp
        response.state = 'fetch-error'
        reject(response)
      })
    })
  }
}

const mutations = {
  setRegistrationStatus (state, data) {
    state.registrationStatus.state = data ? data.state : null
    if (typeof data.response !== 'undefined') { state.registrationStatus.response = data.response }
  },
  setActivationStatus (state, data) {
    state.activationStatus.state = data ? data.state : null
    if (typeof data.response !== 'undefined') { state.activationStatus.response = data.response }
  },
  setLimits4Session (state, data) {
    if (typeof data.singleSessionLimit !== 'undefined') { state.limits4session.singleSessionLimit = data.singleSessionLimit }
    if (typeof data.dailyLimit !== 'undefined') { state.limits4session.dailyLimit = data.dailyLimit }
    if (typeof data.weeklyLimit !== 'undefined') { state.limits4session.weeklyLimit = data.weeklyLimit }
    if (typeof data.monthlyLimit !== 'undefined') { state.limits4session.monthlyLimit = data.monthlyLimit }
    if (typeof data.maxSingleSessionLimit !== 'undefined') { state.limits4session.maxSingleSessionLimit = data.maxSingleSessionLimit }
    if (typeof data.maxDailyLimit !== 'undefined') { state.limits4session.maxDailyLimit = data.maxDailyLimit }
    if (typeof data.maxWeeklyLimit !== 'undefined') { state.limits4session.maxWeeklyLimit = data.maxWeeklyLimit }
    if (typeof data.maxMonthlyLimit !== 'undefined') { state.limits4session.maxMonthlyLimit = data.maxMonthlyLimit }
  },
  setLimits4SessionStatus (state, data) {
    state.limits4sessionStatus.state = data ? data.state : null
  },
  setLimits4DepositStatus (state, data) {
    state.limits4depositStatus.state = data ? data.state : null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js